import axios from 'axios'
import {host} from './base.api.js'
var url = {
  pickRedPacket: host + '/api/socialagent/user/subject/pickredpacket',
  redPacketComplete: host + '/api/socialagent/user/subject/redpacketcomplete'
}
export default {
  pickRedPacket () {
    var http = axios.post(url.pickRedPacket, {
      t: (new Date()).getTime()
    }
    )
    return http
  },
  redPacketComplete () {
    var http = axios.post(url.redPacketComplete, {
      t: (new Date()).getTime()
    }
    )
    return http
  }
}



// WEBPACK FOOTER //
// ./src/api/subject.js